import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select } from 'antd';
import { get } from 'lodash';
// Services
import i18n from 'services/i18n';
// Options
import { IS_CRITERIA, MARITAL_STATUS } from 'constants/options';

@i18n('form')
export default class MaritalStatusForm extends Component {
  static propTypes = {
    record: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
  };

  render() {
    const { record, translate } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      <Form>
        <Input.Group compact>
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator('isSimPatHasCriterion', {
              initialValue: record.criterion.isSimPatHasCriterion
                ? 'is'
                : 'isnt',
            })(
              <Select
                style={{ marginRight: 10 }}
                placeholder={translate('chooseOptions')}
                onClick={e => e.stopPropagation()}
              >
                {IS_CRITERIA.map(item => (
                  <Select.Option key={item.value} value={item.value}>
                    {translate(item.value)}
                  </Select.Option>
                ))}
              </Select>,
            )}
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator('maritalStatus', {
              initialValue: get(
                record,
                'criterion.maritalStatus',
                'CIVIL_UNION',
              ),
            })(
              <Select
                placeholder={translate('chooseMaritalStatus')}
                onClick={e => e.stopPropagation()}
              >
                {MARITAL_STATUS.map(item => (
                  <Select.Option key={item.value} value={item.value}>
                    {translate(item.value)}
                  </Select.Option>
                ))}
              </Select>,
            )}
          </Form.Item>
        </Input.Group>
      </Form>
    );
  }
}
